import { useContext, useEffect } from 'react';

import { TouchpointSubjectStateContext } from './TouchpointSubjectContextProvider';

import TouchpointSubjectData from './TouchpointSubjectData';

const useTouchpointSubjectData = () => {
  const [touchpointSubjectState, setTouchpointSubjectState] = useContext(TouchpointSubjectStateContext);

  useEffect(() => {
    if (touchpointSubjectState.isLoading !== true && touchpointSubjectState.isLoaded !== true) {
      TouchpointSubjectData.getTouchpointSubjects(touchpointSubjectState, setTouchpointSubjectState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    touchpointSubjectState
  };
};

export default useTouchpointSubjectData;